import { Box, Heading, Text, Stack, Icon, Center } from "@chakra-ui/react";
import { TECH_STACK_LIST } from "./constants";
import { SectionDivider } from "app/components/shared/SectionDivider";

export const TechStackCard = (props: {
  heading: string;
  content: string;
  icon: React.ComponentType;
}) => {
  const { heading, content, icon } = props;
  return (
    <Box backgroundColor={"white"} padding={{ base: "15px", sm: "20px" }} role="group">
      <Stack direction={{ base: "column", sm: "row" }} alignItems={"center"} gap="20px">
        <Center
          minWidth={"100px"}
          maxWidth="100px"
          minHeight={"100px"}
          maxHeight="100px"
          borderRadius={"50%"}
          borderWidth="1px"
          borderColor={"brand.300"}
          _groupHover={{ backgroundColor: "brand.300" }}
        >
          <Icon
            as={icon}
            color="brand.100"
            fontSize={"50px"}
            display="flex"
            alignItems={"center"}
            _groupHover={{ color: "white" }}
          />
        </Center>
        <Box flex="1 1 1">
          <Heading
            as={"h3"}
            fontSize={"18px"}
            fontFamily={"Poppins, Sans-serif"}
            marginBottom="15px"
            color="brand.300"
            textAlign={{ base: "center", sm: "left" }}
          >
            {heading}
          </Heading>
          <Text
            fontSize={"18px"}
            fontFamily={"Lato, Sans-serif"}
            color="gray.600"
            textAlign={{ base: "center", sm: "left" }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

const TechStack = () => {
  return (
    <Stack spacing={6} paddingX={8}>
      <SectionDivider
        label="CloudMyLab Ansible Tech Stack"
        bg="transparent"
        padding={"2.25rem 0"}
      />
      <Stack spacing={6} data-cy="section-tech-stack" backgroundColor={"#F1F8FF"} p={10}>
        {TECH_STACK_LIST.map((stack, index) => (
          <TechStackCard {...stack} key={index} />
        ))}
      </Stack>
    </Stack>
  );
};

export default TechStack;
